<form name="frmGroupAccess" style="margin-top:-1.5%;">
    <div class="col-md-12" style="padding-left:0%;padding-right:0%;min-height:80vh;background-color: #f4f8f6;">
        <!-- <div class="container panel panel-default col-md-12" style="padding-left:0%;padding-right:0%;border-color:black;min-height:80vh;background-color: #f4f8f6;">

        <div class="panel panel-heading" style="padding-left:15px;padding-top: 0px;padding-bottom: 0px; background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.4%; color: white;">Group Access</div>
        <br />-->
        <div class="panel-body">
            <div class="form-group row" style="margin-top:-2%;">
                <div class="col-sm-12">
                    <div class="form-group">
                        <div class="col-sm-3">
                            <label for="txtGrpid">Group ID</label>
                            <input type="text" class="form-control" id="txtGrpid" name="txtGrpid" [(ngModel)]="txtGrpid" autocomplete="off" />
                        </div>
                        <div class="col-sm-3">
                            <label for="dlstCountry">Country</label>
                            <select id="dlstCountry" name="dlstCountry" [(ngModel)]="dlstCountries" class="form-control " style="height:33px;">
                                <option value="">&lt;--Select--&gt;</option>
                                <option *ngFor="let C of Countries">{{C.Country}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="formdivcaptions" style="margin-top:2%;">
                        <div align="left">
                            <button type="submit" id="btnSearch" class="btn btn-default btn-group-sm Button1" (click)="ShowData()"><span class="fa fa-search-plus" aria-hidden="true"></span> Search</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <button type="submit" id="searchClear" class="btn btn-default btn-group-sm Button1" (click)="clear()"><span class="fa fa-close" aria-hidden="true"></span> Clear</button>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row" id="divgroupaccessDetails" style="display:none;margin-top:-1%;margin-top: 20px;">
                <div style="margin-left: 20px;margin-right: 20px;">
                    <table id="DeviceDetail" class="table table-bordered" border="1" style="margin-left:1%;width:100%; font-size: 13px;">
                        <thead style="background: linear-gradient(to bottom,#460073 0%, #A100FF 100%); filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2e3b46', endColorstr='#2e3b46',GradientType=0 ); ">
                            <tr>
                                <th style="display:none;color: whitesmoke;">S.No</th>
                                <th style="display:none;color: whitesmoke;">roleid</th>

                                <th></th>
                                <th style="text-align: center;width:25%;color: whitesmoke;">Group ID</th>
                                <th style="text-align: center;color: whitesmoke;width: 30%;">Role</th>
                                <th style="text-align: center;color: whitesmoke;">Country</th>
                                <th style="text-align: center;color: whitesmoke;">Device Type</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let data of successfulData.accesss">
                            <tr *ngIf="data.Id != successfulData.selected.Id">
                                <td>
                                    <img src="../../../assets/img/Edit-icon.png" title="Edit" (click)="EditAccess(data)" />
                                    <img src="../../../assets/img/Delete.png" title="Delete" (click)="DeleteAccess(data)" />
                                </td>
                                <td style="display:none;">{{data.Id}}</td>
                                <td style="display:none;">{{data.roleId}}</td>

                                <td>{{data.GroupID}}</td>
                                <td>{{data.roleName}}</td>
                                <td>{{data.Country}}</td>
                                <td>{{data.DeviceType}}</td>
                            </tr>
                            <tr *ngIf="data.Id === successfulData.selected.Id">
                                <td>
                                    <img src="../../../assets/img/Add.png" (click)="UpdateAccess(data)" title="Update" />
                                    <img src="../../../assets/img/Cancel.jpg" (click)="Reset()" title="Cancel" />
                                </td>
                                <td style="display:none;">{{successfulData.selected.Id}}</td>
                                <td style="display:none;">{{successfulData.selected.roleId}}</td>
                                <td>
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <input type="text" class="form-control" [(ngModel)]="successfulData.selected.GroupID" id="grdgroupName" name="grdgroupName" required />
                                </td>
                                <td>
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <select style="margin-bottom:2px;height:35px" [(ngModel)]="successfulData.selected.selectedRoleName" id="grdRoles" name="grdRoles" class="form-control " required>
                                        <option value="">&lt;--Select--&gt;</option>
                                        <option *ngFor="let R of Roles" [ngValue]="R.roleName">{{R.roleName}}</option>
                                    </select>
                                </td>
                                <td>
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <select style="margin-bottom:2px;height:35px" [(ngModel)]="successfulData.selected.Country" id="grdCountry" name="grdCountry" class="form-control " required>
                                        <option value="">&lt;--Select--&gt;</option>
                                        <option value="All">All</option>
                                        <option *ngFor="let C of Countries" [ngValue]="C.Country">{{C.Country}}</option>
                                    </select>
                                </td>
                                <td>
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <select style="margin-bottom:2px;height:35px" [(ngModel)]="successfulData.selected.DeviceType" id="grdDeviceType" name="grdDeviceType" class="form-control " required>
                                        <option value="">&lt;--Select--&gt;</option>
                                        <option value="Cisco">Cisco</option>
                                        <option value="All">All</option>
                                        <option value="Teams">Teams</option>
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <button id="btnAdd" type="button" class="btn btn-default btn-group-sm Button2" (click)="AddAccess()">
                                        <span class="fa fa-check-circle" aria-hidden="true">
                                        </span> Add
                                    </button>
                                </td>
                                <td>
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <input type="text" class="form-control" [(ngModel)]="GroupAccess.GroupID" id="grdfgroupName" name="grdfgroupName" placeholder="Enter Group ID" required />
                                </td>
                                <td>
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <select [(ngModel)]="GroupAccess.roleId" id="grdFRole" name="grdFRole" class="form-control " aria-label="grdFRole" required>
                                        <option value="">&lt;--Select--&gt;</option>                                        
                                        <option  *ngFor="let R of Roles" [ngValue]="R.roleId">{{R.roleName}}</option>
                                    </select>
                                </td>
                                <td>
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-2%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <select [(ngModel)]="GroupAccess.Country" id="grdfCountry" name="grdfCountry" class="form-control " aria-label="grdfCountry" required>
                                        <option value="">&lt;--Select--&gt;</option>
                                        <option value="All">All</option>
                                        <option *ngFor="let C of Countries">{{C.Country}}</option>
                                    </select>
                                </td>
                                <td>
                                    <div style="color: red; width: 0.5%; padding-left: 0%; padding-right: 0%;margin-left:-5%;margin-top:2%;" class="col-md-1">
                                        <span>*</span>
                                    </div>
                                    <select [(ngModel)]="GroupAccess.DeviceType" id="grdfDeviceType" name="grdfDeviceType" class="form-control " aria-label="grdfDeviceType" required>
                                        <option value="">&lt;--Select--&gt;</option>
                                        <option value="Cisco">Cisco</option>
                                        <option value="All">All</option>
                                        <option value="Teams">Teams</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="11" style="text-align: center;">

                                    <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                            <a><i (click)="setPage(1)" class="icon-fast-backward"></i>
                                            </a>
                                        </li>
                                        <li [ngClass]="{disabled:pager.currentPage === 1}">
                                            <a><i (click)="setPage(pager.currentPage - 1)" class="icon-step-backward"></i></a>
                                        </li>
                                        <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                                            <a (click)="setPage(page)">{{page}}</a>
                                        </li>
                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5 ">
                                            <a (click)="setPage(pager.startPage + 5)">...</a>
                                        </li>
                                        <li *ngIf="(pager.totalPages - pager.startPage) > 5">
                                            <a (click)="setPage(pager.totalPages)">{{pager.totalPages}}</a>
                                        </li>

                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                            <a><i (click)="setPage(pager.currentPage + 1)" class="icon-step-forward"></i></a>
                                        </li>
                                        <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                                            <a><i (click)="setPage(pager.totalPages)" class="icon-fast-forward"></i></a>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</form>